import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FeeScheduleService} from '../services/fee-schedule.service';
import * as Papa from 'papaparse';

@Component({
    selector: 'app-fee-schedule-import-cvs',
    templateUrl: './fee-schedule-import-cvs.component.html',
    styleUrls: ['./fee-schedule-import-cvs.component.scss']
})
export class FeeScheduleImportCvsComponent implements OnInit {

    csvText: string = '';
    priceList: csvItem[] = [];
    parseErrors: string[] = [];
    importMessages: string[] = [];
    uploading = false;
    uploadButtonText = 'Import This List';

    constructor(
        public dialogRef: MatDialogRef<FeeScheduleImportCvsComponent>,
        private snackBar: MatSnackBar,

        private feeScheduleService: FeeScheduleService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {

        console.log('Data on entry', this.data );
        this.parseErrors = [];

    }

    onValueChaged() {
    // console.log('The csv text', this.csvText);

    }

    onClickPaste() {
        navigator.clipboard.readText().then(
            text => {
                this.csvText = text;
            }
        )
            .catch(error => {
                console.error('Cannot read clipboard text: ', error);
            }
            );

    }
    onClickValidate()  {
    // console.log('The csv text', this.csvText);

      this.priceList= [];

      this.parseErrors=[];


      const parsedData = this.parseCSV(this.csvText);
        console.log(parsedData);

        let counter: number = 0;
        parsedData.forEach(l => {
            counter++;
            // l.code
            const lsprice =  l.price.replaceAll('$', '').replaceAll(',', '').replaceAll('IR', '0').replaceAll('"', '').replaceAll('*', '');
            //l.description;
            let  floatNum: number = parseFloat(lsprice);
            if (isNaN(floatNum)) {
                floatNum = 0.00;
                this.parseErrors.push(l.code + ' ' + lsprice);
            }
              let ldescription = l.description.replaceAll("'", "");

            this.priceList.push({id: counter, code : l.code, sprice: lsprice , price: floatNum, description: ldescription});





            //* **********************************************
            /*
    const lines: string[] = this.csvText.split('\n');

    this.priceList= [];

    this.parseErrors=[];


    let counter : number =0
    lines.forEach(l => {
      counter++;
      const i = l.indexOf(',');
      if(i>0) {
        let lcode = l.substring(0, i);
        let lsprice = l.substring(i, 20);

         lsprice  = lsprice.replaceAll('$', '').replaceAll(',', '').replaceAll('IR', '0').replaceAll('"', '').replaceAll('*', '');

        let  floatNum: number = parseFloat(lsprice);
        if (isNaN(floatNum)) {
          floatNum = 0.00;
          this.parseErrors.push(lcode + " " + lsprice);
        }

        this.priceList.push({id: counter, code : lcode, sprice: lsprice , price: floatNum, description: ''});
      }

*/
        });


    }

    onImportOKClick() {

        let txt = '';

        this.importMessages.forEach(f => {txt += f + '\r\n'; } );

        navigator.clipboard.writeText(txt);

        this.dialogRef.close('OK');


    }

    onClickImport()  {


        this.uploading = true;

        this.feeScheduleService.postImportFeeSceduleFees( this.data.DocFeeScheduleID,  this.priceList ).subscribe(res => {
            this.uploading = false;

            this.importMessages = res;

            this.dialogRef.close('OK');
        });


    }



    parseCSV(csvString: string): any[] {
        const results = Papa.parse(csvString, { header: true, skipEmptyLines: true , delimiter: ',', quoteChar: '"'});
        return results.data as any[];
    }



}

export class csvItem {
    id: number;
    code: string;
    sprice: string;
    price: number;
    description: string;


}

